/* LOGIXA homepage content — PL. Shape must match de.ts exactly. */

export const pl = {
  nav: {
    links: [
      { label: 'Produkt', href: '#plattform' },
      { label: 'Rozwiązania', href: '#disposition' },
      { label: 'Integracje', href: '#integrationen' },
      { label: 'Cennik', href: '#preise' },
      { label: 'Zasoby', href: '/docs' },
    ],
    login: 'Logowanie',
    demo: 'Umów demo',
    menu: 'Menu',
  },

  hero: {
    kicker: 'TRANSPORT MANAGEMENT SYSTEM',
    h1: 'Oprogramowanie TMS dla spedycji, którym nie wystarcza sama dyspozycja.',
    sub: 'Zlecenia, dyspozycja, kierowcy, flota, GPS, dokumenty i rozliczenia w jednej platformie. LOGIXA łączy całą organizację transportu — od zlecenia do faktury.',
    primary: 'Umów demo',
    secondary: 'Zobacz demo na żywo',
    trust: ['Zgodność z RODO', 'Hosting w Niemczech', '9 języków', 'Start w 12 dni'],
    demoNote: 'Dane demonstracyjne',
  },

  mock: {
    search: 'Szukaj…',
    user: 'Max Mustermann',
    role: 'ADMIN',
    nav: ['Przegląd', 'Zlecenia', 'Dyspozycja', 'Pojazdy', 'Kierowcy', 'Planowanie tras', 'GPS', 'Dokumenty', 'Wiadomości', 'Raporty', 'Rozliczenia', 'Ustawienia'],
    live: 'LIVE',
    card: {
      id: 'FLEET-DEMO-118',
      route: 'Hamburg, DE → Rotterdam, NL',
      etaLbl: 'ETA',
      eta: 'Dziś, 14:30',
      driverLbl: 'KIEROWCA',
      driver: 'John D.',
      progress: 64,
    },
    ordersTitle: 'Aktywne zlecenia',
    orders: [
      { id: 'FLEET-DEMO-118', state: 'W TRASIE', tone: 'go' },
      { id: 'FLEET-DEMO-117', state: 'W TRASIE', tone: 'go' },
      { id: 'FLEET-DEMO-116', state: 'ZAŁADUNEK', tone: 'load' },
      { id: 'FLEET-DEMO-115', state: 'ZAPLANOWANE', tone: 'plan' },
      { id: 'FLEET-DEMO-114', state: 'ZAKOŃCZONE', tone: 'done' },
    ],
    kpiTitle: 'KPI dziś',
    kpis: [
      { lbl: 'ZLECENIA', val: '850', delta: '+14 %' },
      { lbl: 'PUSTE PRZEBIEGI', val: '14 %', delta: '−16 %' },
      { lbl: 'PRZYCHÓD', val: '€92K', delta: '+18 %' },
    ],
    statusTitle: 'Status pojazdów',
    status: [
      { n: '104', lbl: 'W TRASIE' },
      { n: '18', lbl: 'ZAŁADUNEK' },
      { n: '7', lbl: 'ROZŁADUNEK' },
      { n: '4', lbl: 'SERWIS' },
      { n: '2', lbl: 'NIEAKTYWNE' },
    ],
    plates: [
      { p: 'HH-LOG 33', tone: 'go' },
      { p: 'B-KT 155', tone: 'acc' },
      { p: 'K-AB 147', tone: 'idle' },
    ],
  },

  integrations: {
    label: 'Integracja z istniejącą\ninfrastrukturą logistyczną',
    items: ['TIMOCOM', 'Trans.eu', 'DATEV', 'Stripe', 'SEPA', 'n8n', 'Make', 'Zapier'],
  },

  platform: {
    kicker: 'PLATFORMA',
    h2: 'Twoja spedycja. Jeden system.',
    sub: 'Bez arkuszy Excel. Bez osobnych systemów dla kierowców, GPS i rozliczeń. Bez szukania informacji w pięciu narzędziach.',
    areas: [
      {
        n: '01',
        title: 'Zlecenia i dyspozycja',
        desc: 'Rejestruj zlecenia, przydzielaj kierowców i pojazdy, planuj trasy i śledź status transportu w czasie rzeczywistym.',
        chips: ['Zlecenia', 'Dyspozycja AI', 'Planowanie tras', 'ePOD'],
      },
      {
        n: '02',
        title: 'Flota i GPS',
        desc: 'Śledź pojazdy na żywo, planuj serwisy, kontroluj TCO i zarządzaj geofencingiem.',
        chips: ['Live GPS', 'TCO', 'Serwis', 'Geofencing'],
      },
      {
        n: '03',
        title: 'Kierowcy i compliance',
        desc: 'Czas pracy, dokumenty, tachograf i przepisy EU 561 w jednym miejscu — zanim terminy staną się problemem.',
        chips: ['Tachograf', 'EU 561', 'ADR', 'Moduł 95'],
      },
      {
        n: '04',
        title: 'Rozliczenia i finanse',
        desc: 'Wynagrodzenia, dodatki, wypłaty i procesy DATEV powiązane bezpośrednio z danymi operacyjnymi transportu.',
        chips: ['Payroll', 'DATEV', 'SEPA', 'Stripe'],
      },
    ],
    cta: 'Poznaj wszystkie funkcje',
  },

  dispatch: {
    kicker: 'INTELIGENTNA DYSPOZYCJA',
    h2: 'Dyspozycja, która myśli.',
    sub: 'LOGIXA uwzględnia kierowców, pojazdy, czasy prowadzenia, dostępność i trasę oraz wspiera dyspozytorów w optymalnym przydziale.',
    points: [
      { title: 'Dyspozycja AI', desc: 'Proponuje kierowcę i pojazd pasujące do zlecenia.' },
      { title: 'Optymalizacja tras', desc: 'Uwzględnia myto, odległość, czasy prowadzenia i paliwo.' },
      { title: 'Diesel Intelligence', desc: 'Planuje tankowania według aktualnych cen paliwa wzdłuż trasy.' },
    ],
    panelTitle: 'Rekomendacja trasy',
    metrics: [
      { lbl: 'Odległość', val: '1 346 km' },
      { lbl: 'Czas jazdy', val: '17 h 25 min' },
      { lbl: 'Myto', val: '€ 128,40' },
      { lbl: 'CO₂', val: '1 245 kg' },
    ],
    stopsTitle: 'Zalecane tankowania',
    live: 'LIVE',
    stops: [
      { city: 'Hannover', price: '€ 1,59', best: false },
      { city: 'Kassel', price: '€ 1,58', best: false },
      { city: 'Frankfurt', price: '€ 1,55', best: true },
      { city: 'Würzburg', price: '€ 1,62', best: false },
    ],
    apply: 'Zastosuj trasę',
    source: 'Źródła cen: Tankerkönig (DE), prix-carburants (FR), E-Control (AT), MITECO (ES)',
  },

  driver: {
    kicker: 'APLIKACJA KIEROWCY',
    h2: 'Kierowca ma wszystko przy sobie.',
    sub: 'Natywne aplikacje na iOS i Android — pełny przebieg trasy od zlecenia do podpisu, także bez zasięgu.',
    flow: ['Odbiór zlecenia', 'Start nawigacji', 'Skan dokumentów', 'Podpis ePOD', 'Zamknięcie trasy'],
    chips: ['iOS', 'Android', 'Tryb offline', 'Bot Telegram', '9 języków'],
    phones: [
      {
        tag: 'ZLECENIE #DE-1107',
        title: 'Hamburg → Rotterdam',
        rows: [
          { lbl: 'ZAŁADUNEK', val: 'Dziś 08:30' },
          { lbl: 'DOSTAWA', val: 'Dziś 14:30' },
          { lbl: 'POJAZD', val: 'HH-LOG 33' },
          { lbl: 'ŁADUNEK', val: '18 palet · 12,4 t' },
        ],
        action: 'Start nawigacji',
      },
      {
        tag: 'DOKUMENTY',
        title: 'Skan CMR',
        rows: [
          { lbl: 'LIST PRZEWOZOWY', val: 'CMR-2026-4471' },
          { lbl: 'STATUS', val: 'Zeskanowano · 2 strony' },
          { lbl: 'POTWIERDZENIE', val: 'Oczekuje' },
        ],
        action: 'Wyślij skan',
      },
      {
        tag: 'ePOD',
        title: 'Potwierdź odbiór',
        rows: [
          { lbl: 'ODBIORCA', val: 'De Vries Logistics BV' },
          { lbl: 'PODPIS', val: 'Zarejestrowany' },
          { lbl: 'ZDJĘCIA', val: '3 załączniki' },
        ],
        action: 'Zamknij trasę',
      },
    ],
  },

  compliance: {
    kicker: 'COMPLIANCE I BEZPIECZEŃSTWO',
    h2: 'Widzieć czasy prowadzenia, zanim staną się problemem.',
    sub: 'Czasy prowadzenia i odpoczynku, dane tachografu oraz wygasające dokumenty w jednym miejscu — z ostrzeżeniem, póki jest czas na reakcję.',
    points: [
      { title: 'EU 561', desc: 'Aktualne czasy prowadzenia i odpoczynku każdego kierowcy, na bieżąco uzgadniane.' },
      { title: 'Tachograf', desc: 'Import plików DDD i kontrola danych kierowcy.' },
      { title: 'Dokumenty', desc: 'Ostrzeżenia przed wygaśnięciem prawa jazdy, ADR i Modułu 95.' },
    ],
    dashDriverLbl: 'Kierowca',
    dashDriver: 'John D.',
    badge: 'ZGODNY',
    bars: [
      { lbl: 'Prowadzenie dziś', val: '7 h 45 / 9 h', pct: 86, tone: 'warn' },
      { lbl: 'Prowadzenie w tygodniu', val: '38 h 10 / 56 h', pct: 68, tone: 'ok' },
      { lbl: 'Następny odpoczynek', val: 'za 1 h 15 min', pct: 42, tone: 'ok' },
    ],
    docsTitle: 'Wygasające dokumenty',
    docs: [
      { lbl: 'Prawo jazdy', val: '12.03.2027', warn: false },
      { lbl: 'Certyfikat ADR', val: '18.05.2027', warn: true },
      { lbl: 'Moduł 95', val: '22.09.2027', warn: false },
    ],
    alerts: '3 AKTYWNE OSTRZEŻENIA',
  },

  onboarding: {
    kicker: 'MIGRACJA',
    h2: 'Wciąż Excel? Żaden problem.',
    sub: 'Przenosimy kierowców, pojazdy i kontrahentów z Excela, CSV lub dotychczasowego TMS.',
    promoTitle: 'Start w 12 dni.',
    promoSub: 'Szybko. Bezpiecznie. Bez ryzyka.',
    promoCta: 'Umów demo',
    steps: [
      { tag: 'DZIEŃ 1', title: 'Przegląd procesów', desc: 'Demo i analiza waszych procesów.' },
      { tag: 'DZIEŃ 2–4', title: 'Start pilotażu', desc: 'Praca pilotażowa na realnych pojazdach.' },
      { tag: 'DZIEŃ 5–8', title: 'Import danych', desc: 'Przeniesienie kierowców, pojazdów i danych podstawowych.' },
      { tag: 'DZIEŃ 9–10', title: 'Szkolenie zespołu', desc: 'Szkolenie dyspozytorów i kierowców.' },
      { tag: 'DZIEŃ 11–12', title: 'Uruchomienie', desc: 'Start produkcyjny z pełnym wsparciem.' },
    ],
  },

  roi: {
    kicker: 'POTENCJAŁ OSZCZĘDNOŚCI',
    h2: 'Co LOGIXA zmienia w waszej flocie.',
    fields: [
      { lbl: 'Pojazdy', unit: '' },
      { lbl: 'Kierowcy', unit: '' },
      { lbl: 'Zlecenia miesięcznie', unit: '' },
      { lbl: 'Śr. km na pojazd rocznie', unit: 'km' },
    ],
    panelTitle: 'POTENCJAŁ ROCZNIE',
    lines: ['Mniej pracy administracyjnej', 'Zoptymalizowane puste przebiegi', 'Optymalizacja paliwa'],
    totalLbl: 'Szacowany potencjał',
    basisLink: 'Pokaż podstawę obliczeń',
    basisClose: 'Ukryj podstawę obliczeń',
    basis: [
      'Administracja: 7,50 € na zlecenie (około 13 minut przy stawce kosztu pracy 34 €/h) plus 15 € na kierowcę miesięcznie za ewidencję czasu i przygotowanie płac.',
      'Puste przebiegi: 18 % udziału pustych kilometrów, z czego 5 % możliwe do uniknięcia dzięki lepszej dyspozycji, przy koszcie 1,04 € za kilometr.',
      'Paliwo: zużycie 30 l na 100 km i 2 centy oszczędności na litrze dzięki planowaniu tankowań wzdłuż trasy — na podstawie cen na żywo z Tankerkönig (DE), prix-carburants (FR), E-Control (AT) i MITECO (ES).',
      'Wszystkie wartości są szacunkiem opartym na typowych założeniach branżowych, a nie gwarantowaną oszczędnością.',
    ],
  },

  pricing: {
    kicker: 'CENNIK',
    h2: 'Przejrzyste ceny. Przewidywalnie. Uczciwie.',
    sub: 'Wybierz plan pasujący do waszej floty. Rezygnacja co miesiąc.',
    allLink: 'Zobacz wszystkie ceny',
    perMonth: '/ miesiąc',
    badge: 'POLECANY',
    cta: 'Umów demo',
    plans: [
      {
        name: 'STARTER', price: '€199', custom: false, scope: 'do 15 pojazdów',
        features: ['Zarządzanie zleceniami', 'Aplikacja kierowcy', 'GPS tracking', 'Wsparcie e-mail'],
      },
      {
        name: 'BUSINESS', price: '€499', custom: false, scope: 'do 50 pojazdów',
        features: ['Wszystkie funkcje Starter', 'Dyspozycja AI', 'Tachograf i EU 561', 'Wsparcie priorytetowe'],
      },
      {
        name: 'ENTERPRISE', price: 'Indywidualnie', custom: true, scope: '50+ pojazdów',
        features: ['Wszystkie funkcje Business', 'Rozszerzone uprawnienia', 'API i integracje', 'Dedykowany opiekun'],
      },
    ],
    note: ['Mniejsze floty startują taniej: ', 'BASIC od 49 €/miesiąc', ' do 3 pojazdów, ', 'DRIVER bezpłatnie', ' dla jednoosobowych firm z jedną ciężarówką.'],
  },

  security: {
    title: 'Wasze dane zostają w Europie.',
    items: ['Hosting w Niemczech', 'Zgodność z RODO', '2FA i Passkeys', 'Logi audytowe', 'Szyfrowanie danych'],
  },

  faq: {
    kicker: 'FAQ',
    h2: 'Częste pytania o oprogramowanie TMS.',
    sub: 'Zostały pytania? Odpowiemy na nie podczas demo.',
    list: [
      {
        q: 'Czym jest oprogramowanie TMS?',
        a: 'Transport Management System łączy obsługę zleceń, dyspozycję, zarządzanie pojazdami i kierowcami, dokumenty oraz rozliczenia w jednej platformie — zamiast osobnych arkuszy Excel, portali GPS i programów księgowych.',
      },
      {
        q: 'Dla jakich firm transportowych jest LOGIXA?',
        a: 'Dla spedycji i firm transportowych od 3 do ponad 50 pojazdów. Jednoosobowe firmy z jedną ciężarówką startują na bezpłatnym planie DRIVER, małe floty na BASIC od 49 €/miesiąc, średnie firmy na STARTER lub BUSINESS.',
      },
      {
        q: 'Czy LOGIXA zastąpi Excel?',
        a: 'Tak. Zlecenia, kierowcy, pojazdy, dane podstawowe i rozliczenia są w jednej bazie zamiast w rozproszonych arkuszach. Istniejące pliki Excel i CSV przenosimy przy migracji — startujecie na własnych danych.',
      },
      {
        q: 'Ile trwa wdrożenie?',
        a: 'Planujemy migrację w 12 dni: analiza procesów, praca pilotażowa na realnych pojazdach, import danych, szkolenie i uruchomienie. To nasz sposób pracy, a nie średnia zmierzona na projektach klientów.',
      },
      {
        q: 'Czy mogę zostawić obecny GPS?',
        a: 'W wielu przypadkach tak. LOGIXA zbiera pozycje przez aplikację kierowcy bez dodatkowego sprzętu i może równolegle przyjmować dane telematyczne z istniejących systemów. Możliwy wariant połączenia ustalamy przed startem.',
      },
      {
        q: 'Czy LOGIXA obsługuje tachograf i EU 561?',
        a: 'Czasy prowadzenia i odpoczynku według EU 561 są analizowane na bieżąco dla każdego kierowcy, wraz z ostrzeżeniami przed przekroczeniem. Pliki DDD z tachografu można importować i przeglądać; analiza nie jest przeznaczona jako urzędowa interpretacja tachografu dla organów kontroli.',
      },
      {
        q: 'Czy jest aplikacja dla kierowcy?',
        a: 'Tak, natywne aplikacje na iOS i Android w dziewięciu językach: zlecenie, nawigacja, skan dokumentów, podpis ePOD i zamknięcie trasy — także offline. Dodatkowo dostępny jest bot Telegram dla kierowców bez zainstalowanej aplikacji.',
      },
      {
        q: 'Czy LOGIXA połączy się z TIMOCOM i Trans.eu?',
        a: 'Konektory są przygotowane i napisane zgodnie z udokumentowanymi interfejsami. Aktywacja odbywa się przez waszą własną umowę z TIMOCOM lub Trans.eu; podczas wdrożenia konfigurujemy połączenie wspólnie i testujemy je na waszych danych dostępowych.',
      },
      {
        q: 'Gdzie przechowywane są dane?',
        a: 'Na serwerach w Niemczech, zgodnie z RODO, szyfrowane w transmisji i w spoczynku. Dostępy są logowane, logowanie można zabezpieczyć 2FA i Passkeys.',
      },
      {
        q: 'Ile kosztuje LOGIXA?',
        a: 'DRIVER jest bezpłatny dla jednoosobowych firm z jedną ciężarówką, BASIC zaczyna się od 49 €/miesiąc do 3 pojazdów, STARTER kosztuje 199 €/miesiąc do 15 pojazdów, BUSINESS 499 €/miesiąc do 50 pojazdów. Powyżej 50 pojazdów wyceniamy indywidualnie. Wszystkie plany można wypowiedzieć co miesiąc.',
      },
    ],
  },

  finalCta: {
    h2: 'Zobaczcie LOGIXA na własnych procesach transportowych.',
    sub: 'W 30-minutowym demo pokażemy dokładnie te moduły, które są istotne dla waszej floty.',
    primary: 'Umów demo',
    secondary: 'Zobacz demo na żywo',
  },

  footer: {
    tagline: 'Oprogramowanie TMS dla spedycji i firm transportowych w Europie.',
    cols: [
      {
        title: 'PRODUKT',
        links: [
          { label: 'Funkcje', href: '/platform/funktionen' },
          { label: 'Dyspozycja AI', href: '/platform/ki' },
          { label: 'Aplikacja kierowcy', href: '/platform/funktionen#apps' },
          { label: 'Planowanie tras', href: '/platform/funktionen#tourenplanung' },
          { label: 'Rozliczenia', href: '/platform/backoffice' },
        ],
      },
      {
        title: 'ROZWIĄZANIA',
        links: [
          { label: 'Małe spedycje', href: '/pricing' },
          { label: 'Średnie floty', href: '/pricing' },
          { label: 'Transport dalekobieżny', href: '/platform/funktionen' },
          { label: 'Kierowcy na swoim', href: '/pricing' },
        ],
      },
      {
        title: 'INTEGRACJE',
        links: [
          { label: 'TIMOCOM', href: '/platform/integrationen' },
          { label: 'Trans.eu', href: '/platform/integrationen' },
          { label: 'DATEV', href: '/platform/integrationen' },
          { label: 'Telegram', href: '/platform/integrationen' },
          { label: 'Wszystkie integracje', href: '/platform/integrationen' },
        ],
      },
      {
        title: 'ZASOBY',
        links: [
          { label: 'Baza wiedzy', href: '/docs' },
          { label: 'Blog', href: '/blog' },
          { label: 'Czym jest TMS?', href: '/docs' },
          { label: 'Koszty TMS', href: '/pricing' },
          { label: 'Centrum pomocy', href: '/docs' },
        ],
      },
      {
        title: 'FIRMA',
        links: [
          { label: 'O nas', href: '/about' },
          { label: 'Kariera', href: '/jobs' },
          { label: 'Partnerzy', href: '/companies' },
          { label: 'Kontakt', href: '/kontakt' },
        ],
      },
    ],
    copyright: '© 2026 LOGIXA. Wszelkie prawa zastrzeżone.',
    legal: [
      { label: 'Prywatność', href: '/datenschutz' },
      { label: 'Impressum', href: '/impressum' },
      { label: 'Regulamin', href: '/agb' },
      { label: 'Bezpieczeństwo', href: '/platform/funktionen#sicherheit' },
    ],
  },
};
